import styled from "styled-components";
import { SkeletonLine } from "../../Componentes/Utils/SkeletonLine";

const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    background-color: #FAFCFC;
    border: 1px solid #ececec;
    border-radius: 10px;
    padding: 8px 12px;
    min-width: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Label = styled.span`
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: #ACAFB0;
    text-transform: uppercase;
`;

const Value = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: #263B4B;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const InfoField = ({ title, value, loading }) => {
    return (
        <Field>
            {loading ? (
                <>
                    <SkeletonLine style={{ height: "8px", width: "45%", margin: "2px 0" }} />
                    <SkeletonLine style={{ height: "12px", width: "75%", margin: "2px 0 0" }} />
                </>
            ) : (
                <>
                    <Label>{title}</Label>
                    <Value title={typeof value === "string" ? value : undefined}>{value}</Value>
                </>
            )}
        </Field>
    )
}

export default InfoField;
